import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=64163812&scoped=true&"
import script from "./Screenshot.vue?vue&type=script&lang=ts&"
export * from "./Screenshot.vue?vue&type=script&lang=ts&"
import style0 from "./Screenshot.vue?vue&type=style&index=0&id=64163812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64163812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressCircular,VTextField})
